import { LoadMask } from 'ehs-react';
import React from 'react';
import { useLoginCredentialsStore } from '../stores/loginCredentials.store';

export function LoginLoadMask(): JSX.Element {
  const loading = useLoginCredentialsStore(state => state.pageLoading);
  return <LoadMask className="login-load-mask" masked={loading} />;
}
